import React, { useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useAxiosPrivateUploadFile from "../../../hooks/useAxiosPrivateUploadFile";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import GetParsedDate from "../../shared/GetParsedDate";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  moamad_id,
  docOptions,
  moamad,
  hagsha_aharon,
}) => {
  const [documents, setDocuments] = useState(null);
  const [doc, setDoc] = useState([]);
  const [loading, setLoading] = useState(true);
  const [docId, setDocId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const readOnly =
    !(
      moamad?.extention_date &&
      MyJustDate(new Date(Date.parse(moamad?.extention_date))) >=
        MyJustDate(Date.now())
    ) &&
    (moamad.signature_date ||
      MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now()));
  /* const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());*/

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "jobs/moamaddocument?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setDocuments(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);

  const handleEditClick = (event, doc) => {
    event.preventDefault();
    setDocId(doc.id);
  };
  const handleCancelClick = () => {
    setDocId(null);
  };

  if (!documents) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>המסמך</th>
                      <th>סוג המסמך</th>
                      <th>תאריך העלאה</th>
                      <th>משתמש</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents?.map((doc) => (
                      <Fragment key={doc.id}>
                        {docId === doc.id ? (
                          <Edit
                            doc={doc}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setDocId={setDocId}
                            docOptions={docOptions}
                            extention_date={moamad.extention_date}
                          />
                        ) : (
                          <ReadOnlyRows
                            doc={doc}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setDocId={setDocId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                            readOnly={readOnly}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  doc,
  handleEditClick,
  setDocId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
  readOnly,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const axiosPrivateUploadFile = useAxiosPrivateUploadFile();
  const navigate = useNavigate();
  const location = useLocation();
  const handleDownload = async (event, file_url, documentid) => {
    event.preventDefault();
    const fileName = file_url.split("/").pop();
    try {
      const response = await axiosPrivateUploadFile.get(
        `${baseURL}jobs/moamaddocument/decrypt_file/?documentid=${documentid}`,
        {
          responseType: "blob", // Set the responseType to 'blob'
        },
      );

      if (response.status === 200) {
        // Create a Blob from the response and trigger a download
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        console.error("Failed to fetch decrypted file");
      }
    } catch (error) {
      console.error("Error fetching decrypted file:", error);
    }
  };

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת מסמך "${doc.id}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    async function deletePost() {
      let isMounted = true;
      const controller = new AbortController();
      const getData = async () => {
        try {
          const response = await axiosPrivate.delete(
            baseURL + "jobs/moamaddocument/" + doc.id + "/",
            {
              signal: controller.signal,
            },
          );
          isMounted && increment();
          alert("נמחקה בהצלחה");
        } catch (err) {
          if (err.response) {
            alert(HandleHttpErrors(err.response.status));
            if (err.response.status === 401) {
              navigate("/login", { state: { from: location }, replace: true });
            } else if (err.response.status === 403) {
              alert(HandleHttpErrors(err.response.status));
            }
            console.log(err.response);
          } else if (err.request) {
            alert(
              " The client never received a response, and the request was never left",
            );
            console.log(err.request);
          } else {
            console.log(err);
            alert(" Anything else");
          }
        }
      };
      getData();
    }
    deletePost();
    setDocId(null);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={doc.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>
          <button
            type="button"
            className="btn btn-sercondary"
            onClick={(event) => handleDownload(event, doc.file_url, doc.id)}
          >
            <u>הורד את המסמך</u>
          </button>
        </td>
        <td>{doc.doc_type}</td>
        <td>
          <GetParsedDate strDate={doc.log_created_at} withTime={true} />{" "}
        </td>
        <td>{doc.created_by_user}</td>
        <td style={{ textAlign: "left", direction: "rtl" }}>
          <div className="d-flex justify-content-end">
            <button
              disabled={readOnly}
              type="button"
              className="btn btn-success"
              onClick={(event) => handleEditClick(event, doc)}
            >
              <FiEdit2 />
            </button>
            <span> </span>
            <button
              disabled={readOnly}
              type="button"
              className="btn btn-danger space-button"
              onClick={(event) => showDeleteModal("documents", doc.id, event)}
            >
              <FiTrash2 />
            </button>
          </div>
        </td>
      </tr>
    </>
  );
};
